import {
  GETSETTLEMENTREPORTPARTNER_SUCCESS,
  GETSETTLEMENTREPORTPARTNER_FAILED,
  RESET_GETSETTLEMENTREPORTPARTNER,
  LOADING_GETSETTLEMENTREPORTPARTNER,
  NETWORK_ERROR_GETSETTLEMENTREPORTPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetSettlementReportPartner = () => {
  return { type: RESET_GETSETTLEMENTREPORTPARTNER };
};

const getSettlementReportPartnerS = (userData, authTokenIs) => async (dispatch) => {

  const authToken = sessionStorage.getItem("authToken") || authTokenIs;
  console.log("authToken",authToken)

  dispatch({ type: LOADING_GETSETTLEMENTREPORTPARTNER });
  await partnerServices
    .post("getSettlement", userData, { headers: { AuthToken: authToken } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getSettlementReportPartnerSuccess(res.data));
          break;
        default:
          dispatch(getSettlementReportPartnerFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETSETTLEMENTREPORTPARTNER, payload: err });
    });
};
function getSettlementReportPartnerSuccess(data) {
  return {
    type: GETSETTLEMENTREPORTPARTNER_SUCCESS,
    payload: data,
  };
}
function getSettlementReportPartnerFailed(data) {
  return {
    type: GETSETTLEMENTREPORTPARTNER_FAILED,
    payload: data,
  };
}

export { resetGetSettlementReportPartner, getSettlementReportPartnerS };
